import Loading from "./components/Loading";
import Loadable from "react-loadable";

// news page
export const News = Loadable({
  loader: () => import("./components/news-page/News"),
  loading: Loading,
});

export const SingleArticle = Loadable({
  loader: () => import("./components/news-page/SingleArticle"),
  loading: Loading,
});

// games page
export const Games = Loadable({
  loader: () => import("./components/games-page/Games"),
  loading: Loading,
});

export const Deceive = Loadable({
  loader: () => import("./components/games-page/deceive-page/Deceive"),
  loading: Loading,
});

export const ManEater = Loadable({
  loader: () => import("./components/games-page/maneater-page/ManEater"),
  loading: Loading,
});

export const KillingFloorIncursion = Loadable({
  loader: () =>
    import("./components/games-page/kf-incursion-page/KillingFloorIncursion"),
  loading: Loading,
});

export const KillingFloor = Loadable({
  loader: () =>
    import("./components/games-page/killing-floor-page/KillingFloor"),
  loading: Loading,
});

export const RedOrchestra = Loadable({
  loader: () =>
    import("./components/games-page/red-orchestra-page/RedOrchestra"),
  loading: Loading,
});

export const RisingStorm = Loadable({
  loader: () => import("./components/games-page/rising-storm-page/RisingStorm"),
  loading: Loading,
});

export const TheBall = Loadable({
  loader: () => import("./components/games-page/the-ball-page/TheBall"),
  loading: Loading,
});

export const ZenoClash = Loadable({
  loader: () => import("./components/games-page/zeno-clash-page/ZenoClash"),
  loading: Loading,
});

export const Dwarfs = Loadable({
  loader: () => import("./components/games-page/dwarfs-page/Dwarfs"),
  loading: Loading,
});

export const Espire1 = Loadable({
  loader: () => import("./components/games-page/espire1-page/Espire1"),
  loading: Loading,
});

export const Espire2 = Loadable({
  loader: () => import("./components/games-page/espire2-page/Espire2"),
  loading: Loading,
});

export const RO2 = Loadable({
  loader: () => import("./components/games-page/red-orchestra-2-page/RO2"),
  loading: Loading,
});

// publishing page
export const Publishing = Loadable({
  loader: () => import("./components/company-page/publishing-page/Publishing"),
  loading: Loading,
});

// careers page
export const Jobs = Loadable({
  loader: () => import("./components/company-page/careers-page/Jobs"),
  loading: Loading,
});

// company page and policies
export const Company = Loadable({
  loader: () => import("./components/company-page/Company"),
  loading: Loading,
});

export const VideoPolicy = Loadable({
  loader: () =>
    import("./components/company-page/company-policies/VideoPolicy"),
  loading: Loading,
});

export const EndUserLicenseAgreement = Loadable({
  loader: () =>
    import(
      "./components/company-page/company-policies/EndUserLicenseAgreement"
    ),
  loading: Loading,
});

export const PrivacyNotice = Loadable({
  loader: () =>
    import("./components/company-page/company-policies/PrivacyNotice"),
  loading: Loading,
});

export const Cookies = Loadable({
  loader: () => import("./components/company-page/company-policies/Cookies"),
  loading: Loading,
});

export const Signup = Loadable({
  loader: () => import("./components/company-page/signup-page/Signup"),
  loading: Loading,
});



// WEBPACK FOOTER //
// ./src/LazyLoading.js